import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export const steps = [
    {
        id: '0',
        name: capitalize(i18n.t("description"))
    },
    {
        id: '1',
        name: i18n.t("contact")
    },
    {
        id: '2',
        name: i18n.t("dimensions")
    }
]